import { Portal } from '@shared/layouts/portal/portal'
import cn from 'classnames'

import { LoaderLogo } from '@components/loader-logo/loader-logo'

import styles from './loader-full-screen.module.css'

type LoaderFullScreenProps = {
  className?: string
}

export const LoaderFullScreen = ({ className }: LoaderFullScreenProps) => {
  return (
    <Portal>
      <div className={cn(styles.container, className)}>
        <LoaderLogo />
      </div>
    </Portal>
  )
}
